import { render } from "./NewProbation.vue?vue&type=template&id=74de37ac&scoped=true"
import script from "./NewProbation.vue?vue&type=script&lang=js"
export * from "./NewProbation.vue?vue&type=script&lang=js"

import "./NewProbation.vue?vue&type=style&index=0&id=74de37ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74de37ac"]])

export default __exports__